// init controller
var controller = new ScrollMagic.Controller({
    globalSceneOptions: {
        duration: "100%"
    }
});

// build scenes
new ScrollMagic.Scene({triggerElement: "#prospective-clients"})
    .setClassToggle("#navLink7", "is-current")
    .addTo(controller);
new ScrollMagic.Scene({triggerElement: "#careers"})
    .setClassToggle("#navLink6", "is-current")
    .addTo(controller);
new ScrollMagic.Scene({triggerElement: "#speaking-engagements"})
    .setClassToggle("#navLink5", "is-current")
    .addTo(controller);
new ScrollMagic.Scene({triggerElement: "#community"})
    .setClassToggle("#navLink4", "is-current")
    .addTo(controller);
new ScrollMagic.Scene({triggerElement: "#press"})
    .setClassToggle("#navLink3", "is-current")
    .addTo(controller);
new ScrollMagic.Scene({triggerElement: "#jump-alumni"})
    .setClassToggle("#navLink2", "is-current")
    .addTo(controller);
new ScrollMagic.Scene({triggerElement: "#general-inquiries"})
    .setClassToggle("#navLink1", "is-current")
    .addTo(controller);



// Swap header to light based on scroll position
$('[data-header="light"]').each(function() {
    new ScrollMagic.Scene({
        duration: '100%',
        triggerElement: this,
        triggerHook: 'onLeave',
    })
    .setClassToggle("#siteHeader", "site-header-light")
    .addTo(controller);
});

// Swap header to dark based on scroll position
$('[data-header="dark"]').each(function() {
    new ScrollMagic.Scene({
        duration: '100%',
        triggerElement: this,
        triggerHook: 'onLeave',
    })
    .setClassToggle("#siteHeader", "site-header-dark")
    .addTo(controller);
});


// adds blue handwritten smilie when prospective clients is in view
var scene = new ScrollMagic.Scene({
    triggerElement: "#prospective-clients",
    duration: "100%",
})
.on('enter', function (event) {
    scribbleSmilieEnter();
})
.on('leave', function (event) {
    scribbleSmilieLeave();
})
.addTo(controller);


scribbleSmilieEnter = function() {
    if ($('.js-animate-smilie').hasClass('is-current')) {
        setTimeout(function() {
            $('.smilie-scribble')
                .html('<object type="image/svg+xml" data="/assets/images/scribbles/animated/scribble-smilie-load.svg" height="27" width="29">Hand drawn element</object>');
        }, 1500);
    }
}
scribbleSmilieLeave = function() {
    $('.smilie-scribble').html('');
}

$(document).ready(function () {
    // Define the key-to-section mapping
    const keyMap = {
        "1": "#general-inquiries",
        "2": "#jump-alumni",
        "3": "#press",
        "4": "#community",
        "5": "#speaking-engagements",
        "6": "#careers",
        "7": "#prospective-clients",
        "g": "#general-inquiries" // 'G' (or 'g') maps to section 1
    };

    // Listen for keydown events
    $(document).on("keydown", function (event) {
        // Ignore if a modifier key (Cmd, Ctrl, Alt, Shift) is held
        if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) {
            return;
        }

        // Ignore keypress if an input, textarea, or contenteditable element is focused
        if ($("input:focus, textarea:focus, [contenteditable=true]").length) {
            return;
        }

        // Get the pressed key
        const keyPressed = event.key.toLowerCase();

        // Check if the key is mapped to a section
        if (keyMap.hasOwnProperty(keyPressed)) {
            event.preventDefault();

            const sectionID = keyMap[keyPressed];
            const target = $(sectionID);

            if (target.length) {
                $("html, body").animate(
                    { scrollTop: target.offset().top },
                    600
                );
            }
        }
    });
});
